<template>
    <v-dialog
      v-model="dialog"
      scrollable
      max-width="750px">
      <template v-slot:activator="{ on, attrs }">
        <div v-bind="attrs" v-on="on" style="cursor: pointer;">
            <v-icon style="cursor:pointer;">
                mdi-import
            </v-icon>
            <span>Import Record</span>
        </div>
      </template>
      <v-card>
        <v-card-title>Import Record</v-card-title>
        <v-card-text>Paste the JSON file from the recrods section here. </v-card-text>
        <v-card-text class="pa-4"> <!-- Added padding here -->
          <!-- Importing feedback -->
          <div v-if="importing" class="d-flex justify-center">
            <v-progress-circular indeterminate size="32"></v-progress-circular>
          </div>
          <!-- Textarea for raw JSON data input -->
          <div v-else class="d-flex justify-center">
            <v-textarea
              v-model="importData"
              rows="10"
              outlined
              style="max-width: auto;"
            ></v-textarea>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="primary darken-1" text @click="importRecord">Import</v-btn>
          <v-btn color="red darken-1" text @click="dialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>

  <script>
  import { EventBus } from '@/js/event-bus.js';

  export default {
    data() {
      return {
        dialog: false,
        importData: '',  // For the JSON string input
        importing: false,
      };
    },
    methods: {
      importRecord() {
        if (this.importing) return;

        // Basic JSON validation
        let parsedData;
        try {
        console.log(this.importData);
          parsedData = JSON.parse(this.importData);
        } catch (e) {
          EventBus.$emit('show-error', 'Invalid JSON format');
          return;
        }

        this.importing = true;

        // Send the parsed JSON to the API
        this.$http.post('/api/integrationrecords/import', parsedData)
          .then(({ data }) => {
            this.importing = false;
            this.dialog = false;
            EventBus.$emit('show-success', 'Record imported successfully');
            // Emit the newly imported record to the parent component
            this.$emit('recordImported', data);
          })
          .catch((err) => {
            EventBus.$emit('show-error', err);
            this.importing = false;
          });
      }
    }
  };
  </script>
